export default "__VITE_ASSET__C1sN9xe6__"